import type { LocaleDictionary } from "@/i18n/types";

const nsAccountMenuJA = {
  trigger: {
    ariaLabel: "アカウントメニュー",
  },
  item: {
    accountSetting: "アカウント設定",
    help: "ヘルプ",
    signOut: "ログアウト",
  },
  adminGroup: {
    header: "管理者",
    adminPage: "AA管理者用ページ",
  },
  footer: {
    about: "当サービスについて",
  },
  aboutDialog: {
    title: "当サービスについて",
    version: ({ version }: { version: string }) => `バージョン: ${version}`,
    closeButton: "閉じる",
  },
  signOutDialog: {
    title: "ログアウト",
    message: "現在のアカウントからログアウトします。よろしいですか？",
    confirmButton: "ログアウトする",
    cancelButton: "キャンセル",
  },
} satisfies LocaleDictionary;

export default nsAccountMenuJA;
